<template>
  <div>
    <hero></hero>
    <features id="more"></features>
    <certifications></certifications>
    <partners></partners>
    <testimonials></testimonials>
    <history></history>

  </div>
</template>

<script>
  import Hero from './sections/Hero'
  import Features from './sections/Features'
  import Certifications from './sections/Certifications'
  import Partners from './sections/Partners'
  import History from './sections/History'
  import Testimonials from './sections/Testimonials'
  export default {
    name: 'home',
    components: {
      Hero,
      Features,
      Certifications,
      Partners,
      History,
      Testimonials
    }
  }
</script>
